import { Action, createReducer, on } from '@ngrx/store';

import { loadNewsSuccessAction, newsPageResizeAction, showMoreAction } from './actions';
import { NewsListState } from './news-list-state.type';
import { CarouselItem } from '@app/ui-components/carousel/types';
import { NewsItem } from '@app-modules/news/types';

import { NEWS_LIST_ROW_COUNT } from '../constants';

const initialState: NewsListState = {
  newsList: [],
  cursor: 1,
  rowCount: NEWS_LIST_ROW_COUNT.DESKTOP
};

const reducer = createReducer(
  initialState,
  on(
    loadNewsSuccessAction,
    (state, { newsList }): NewsListState => ({
      ...state,
      newsList: mapCarouselItems(newsList)
    })
  ),
  on(
    newsPageResizeAction,
    (state, { rowCount }): NewsListState => ({
      ...state,
      rowCount
    })
  ),
  on(
    showMoreAction,
    (state): NewsListState => ({
      ...state,
      cursor: state.cursor + 1
    })
  )
);
export const newsListReducers = (state: NewsListState, action: Action): NewsListState => reducer(state, action);

const mapCarouselItems = (newsList: NewsItem[]): CarouselItem[] => newsList.map(mapCarouselItem);
const mapCarouselItem = ({ image, label, creationDate, newsTitle }: NewsItem): CarouselItem => ({
  image,
  creationDate,
  description: newsTitle && newsTitle?.length > 100 ? newsTitle?.substring(0, 100) + '...' : newsTitle || '',
  link: { url: label }
});
